export default "__VITE_ASSET__65027c1b__"